import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticleGrid() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-700">
              最新
            </h2>
            <h3 className="text-2xl md:text-3xl font-heading font-bold italic text-foreground-900">
              吃瓜爆料
            </h3>
          </div>
          <p className="text-sm text-foreground-600 max-w-lg leading-relaxed">
            每日精选最新最劲爆的吃瓜爆料内容，涵盖网红黑料、塌房现场、娱乐八卦等多个热门板块，让你不错过任何一个热点事件。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {articles.slice(0, 6).map((article, idx) => {
            const isMiddleCard = idx % 3 === 1;
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group cursor-pointer"
              >
                <article
                  className={`rounded-2xl overflow-hidden transition-transform duration-300 group-hover:scale-[1.02] ${
                    isMiddleCard ? 'bg-primary-500' : 'bg-background-100'
                  }`}
                >
                  <div className="aspect-[3/2] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-3 whitespace-nowrap ${
                        isMiddleCard
                          ? 'bg-accent-500 text-primary-900'
                          : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      {article.category}
                    </span>
                    <h4
                      className={`text-base md:text-lg font-bold leading-snug line-clamp-3 ${
                        isMiddleCard ? 'text-background-50' : 'text-foreground-900'
                      }`}
                    >
                      {article.title}
                    </h4>
                    <div className={`flex items-center gap-3 mt-3 text-xs ${isMiddleCard ? 'text-background-50/60' : 'text-foreground-500'}`}>
                      <span>{article.date}</span>
                      <span>·</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views >= 10000
                          ? `${(article.views / 10000).toFixed(1)}万`
                          : article.views}
                      </span>
                    </div>
                  </div>
                </article>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/chigua-baoliao"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}